import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const STEPS = [
  { n: "01", t: "Find a room, any hour", d: "Search by city, activity and price. See real hourly availability for cafes, churches, studios and more." },
  { n: "02", t: "Book by the hour", d: "Pick a date and time. Total shows the 15% renter service fee up front — no surprises." },
  { n: "03", t: "Show up and use it", d: "Get host details and directions after booking. Rate the space so future renters can trust it." },
];
const HOST_STEPS = [
  { n: "01", t: "List your dead hours", d: "Photos, price, rules. Ninety seconds and you're live." },
  { n: "02", t: "Set the schedule", d: "Only the hours you want to rent. Never a minute more." },
  { n: "03", t: "Get paid", d: "You keep 100% of the rate you set — renters pay a 15% service fee on top. SpareHours handles discovery and booking." },
];

export default function HowItWorks() {
  return (
    <div className="max-w-[1200px] mx-auto px-6 lg:px-10 py-14">
      <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-neutral-500 mb-2">MANUAL</div>
      <h1 className="font-display font-black tracking-tighter text-4xl md:text-6xl leading-[0.98] max-w-3xl">
        Every empty room, on the clock.
      </h1>

      <section className="mt-16">
        <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#FF4500] mb-6">FOR RENTERS</div>
        <div className="grid md:grid-cols-3 gap-4">
          {STEPS.map((s) => (
            <div key={s.n} className="border border-neutral-200 rounded-xl p-6 bg-white">
              <div className="font-display font-black text-4xl">{s.n}</div>
              <div className="font-display font-bold text-lg mt-2">{s.t}</div>
              <div className="text-sm text-neutral-600 mt-2 leading-relaxed">{s.d}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-14 bg-[#0A0A0A] text-white rounded-xl p-8 md:p-12">
        <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-[#FF4500] mb-6">FOR HOSTS</div>
        <div className="grid md:grid-cols-3 gap-4">
          {HOST_STEPS.map((s) => (
            <div key={s.n} className="border border-neutral-800 rounded-xl p-6">
              <div className="font-display font-black text-4xl">{s.n}</div>
              <div className="font-display font-bold text-lg mt-2">{s.t}</div>
              <div className="text-sm text-neutral-300 mt-2 leading-relaxed">{s.d}</div>
            </div>
          ))}
        </div>
        <div className="mt-8">
          <Link to="/host/new">
            <Button className="bg-[#FF4500] hover:bg-[#E63E00] text-white rounded-full h-12 px-8">List a space</Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
